import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'm2km' })
export class MetersToKilometers implements PipeTransform {
  transform(value: any): string {
    if (!value || isNaN(+value)) {
      return value || '';
    }
    const length = +value;
    if (length > 100) {
      // Show in kilometers
      return `${Math.round((length / 1000) * 100) / 100} km`;
    } else {
      // Show in meters
      return `${Math.round(length * 100) / 100} m`;
    }
  }
}

